// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.room-settings-description {
  font-size: 13px;
  color: #666;
  margin-bottom: 20px;
  line-height: 1.5;
}

.permissions-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
  background-color: #f5f5f5;
  border-radius: 8px;
  overflow: hidden;
}

.permission-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background-color: white;
  transition: background-color 0.2s ease;
}

.permission-row:hover {
  background-color: #fafafa;
}

.permission-label {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.permission-control {
  display: flex;
  align-items: center;
  gap: 8px;
}

.permission-select {
  padding: 6px 32px 6px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 13px;
  background-color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 140px;
}

.permission-select:hover:not(:disabled) {
  border-color: #999;
}

.permission-select:focus {
  outline: none;
  border-color: #666;
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.05);
}

.permission-select:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background-color: #f5f5f5;
}

.permission-custom-input-container {
  position: relative;
}

.permission-custom-input {
  padding: 6px 12px;
  border: 1px solid #666;
  border-radius: 6px;
  font-size: 13px;
  width: 140px;
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.05);
}

.permission-custom-input:focus {
  outline: none;
}

.permission-custom-value {
  font-size: 12px;
  color: #666;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.permission-custom-value-clickable {
  cursor: pointer;
}

.permission-custom-value-clickable:hover {
  background-color: #f0f0f0;
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/RoomSettings/PermissionsPage.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".room-settings-description {\n  font-size: 13px;\n  color: #666;\n  margin-bottom: 20px;\n  line-height: 1.5;\n}\n\n.permissions-list {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  background-color: #f5f5f5;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.permission-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px;\n  background-color: white;\n  transition: background-color 0.2s ease;\n}\n\n.permission-row:hover {\n  background-color: #fafafa;\n}\n\n.permission-label {\n  font-size: 14px;\n  color: #333;\n  font-weight: 500;\n}\n\n.permission-control {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.permission-select {\n  padding: 6px 32px 6px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 13px;\n  background-color: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 140px;\n}\n\n.permission-select:hover:not(:disabled) {\n  border-color: #999;\n}\n\n.permission-select:focus {\n  outline: none;\n  border-color: #666;\n  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.05);\n}\n\n.permission-select:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  background-color: #f5f5f5;\n}\n\n.permission-custom-input-container {\n  position: relative;\n}\n\n.permission-custom-input {\n  padding: 6px 12px;\n  border: 1px solid #666;\n  border-radius: 6px;\n  font-size: 13px;\n  width: 140px;\n  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.05);\n}\n\n.permission-custom-input:focus {\n  outline: none;\n}\n\n.permission-custom-value {\n  font-size: 12px;\n  color: #666;\n  font-weight: 500;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.permission-custom-value-clickable {\n  cursor: pointer;\n}\n\n.permission-custom-value-clickable:hover {\n  background-color: #f0f0f0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
